import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export const useGetRuleAssignments = (ruleId: string, { enabled = true } = {}) => {
  return useQuery<{ userIds: string[] }>({
    queryKey: ['notifications', 'rules', ruleId, 'assignments'],
    queryFn: async () => {
      const { data } = await client.get<{ body: { userIds: string[] } }>(
        `/notifications/rules/${ruleId}/assignments`
      );
      return data.body;
    },
    retry: 1,
    enabled: enabled && Boolean(ruleId),
  });
};
